<template>
    <b-container class="releases-content">
        <b-row>
            <b-col><h1>BEATPORT</h1></b-col>
        </b-row>
        <b-row class="release-row bandcamp" v-for="r in beatportReleases" :key="r.key">
            <b-col sm="12" lg="4">
                <b-img fluid v-bind:src="r.imgSrc" />
            </b-col>
            <b-col sm="12" lg="8">
                
                <h2>{{r.name}}</h2>
                <div class="genre-badges d-inline"><b-badge variant="dark">{{r.genre}}</b-badge></div>
                <h6 class="release-date d-inline">{{r.releaseDate}}</h6>
                <p class="card-text">
                    {{r.description}}
                </p>
                <b-button class="purchase-button" v-bind:href="r.beatportUrl" variant="success">Purchase {{r.catalog}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col><h1>FREE RELEASES</h1></b-col>
        </b-row>
        <b-row class="release-row bandcamp" v-for="r in bandcampReleases" :key="r.key">
            <b-col><iframe style="border: 0; width: 100%; height: 120px;" v-bind:src="r.src" seamless><a v-bind:href="r.href">{{r.title}}</a></iframe></b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    data () {
        return {
            beatportReleases: [
                {
                    imgSrc: "https://geo-media.beatport.com/image/86be9417-5cdc-42fe-82c2-b7c0d6ff7e8c.jpg",
                    name: "SLOUNCH / STEEL",
                    genre: "Drum & Bass",
                    artists: "DValue, Resykle",
                    releaseDate: "2018-03-23",
                    catalog: "EMP002",
                    description: "Drum and Bass music from our very own Resykle and DValue",
                    beatportUrl: "https://www.beatport.com/release/slounch-steel/2234899"
                },
                {
                    imgSrc: "https://geo-media.beatport.com/image/7c270adb-8772-4c3e-9710-baaa659d3a52.jpg",
                    name: "EMPT-001",
                    genre: "Techno",
                    artists: "DValue, WYRaM, Caidance, Gravekeepr, Daeman",
                    releaseDate: "2018-03-16",
                    catalog: "EMP001",
                    description: "EMPT-001 is the start of a new series of techno releases brought to you by the EMP Radio family. Our first EP offers explorations in bass, melodic, cosmic, and acid techno from the likes of Dvalue, Daeman, Caidance, WYRaM, and Gravekeepr.",
                    beatportUrl: "https://www.beatport.com/release/empt-001/2234915"
                }
            ],
            bandcampReleases: [ {
                    src: "https://bandcamp.com/EmbeddedPlayer/album=974335750/size=large/bgcol=333333/linkcol=e32c14/tracklist=false/artwork=small/transparent=true/",
                    href: "http://empradio.bandcamp.com/album/emp005-house-techno-compilation",
                    title: "EMP005: House/Techno Compilation by EMP Radio"
                },
                {
                    src: "https://bandcamp.com/EmbeddedPlayer/album=240401848/size=large/bgcol=333333/linkcol=e32c14/tracklist=false/artwork=small/transparent=true/",
                    href: "http://empradio.bandcamp.com/album/emp-x-c9",
                    title: "EMP x C9 by EMP Radio"
                },
                {
                    src: "https://bandcamp.com/EmbeddedPlayer/album=1821798504/size=large/bgcol=333333/linkcol=e32c14/tracklist=false/artwork=small/transparent=true/",
                    href: "http://empradio.bandcamp.com/album/vampire-spooktacular",
                    title: "Vampire Spooktacular by EMP Radio"
                },                
                {
                    src: "https://bandcamp.com/EmbeddedPlayer/album=1666735251/size=large/bgcol=333333/linkcol=e32c14/tracklist=false/artwork=small/transparent=true/",
                    href: "http://empradio.bandcamp.com/album/flux-ep",
                    title: "Flux EP by Ezca"
                },    
                {
                    src: "https://bandcamp.com/EmbeddedPlayer/album=3797499161/size=large/bgcol=333333/linkcol=e32c14/tracklist=false/artwork=small/transparent=true/",
                    href: "http://empradio.bandcamp.com/album/resykle-submosphere-ep",
                    title: "Resykle - Submosphere EP by Resykle"
                }
            ]
        }
    }
}
</script>

<style>
    .release-row {
        margin-top: 10px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }
    .purchase-button.btn-success {
        background-color: #FF5722;
        border-color: #FF5722;
        color: black;
    }
    .purchase-button.btn-success:hover {
        background-color: rgb(255, 68, 11);
        border-color: rgb(255, 68, 11);
    }
    .card-text {
        padding-top: 20px;
    }
    .genre-badges {
        margin-bottom: 10px;
    }
    .release-date {
        color: grey;
    }
    .genre-badges .badge {
        font-size: 100%;
    }
    #player {
        max-width: 100%!important;
    }
</style>



// WEBPACK FOOTER //
// src/Releases.vue